<template>
  <div class="article-main">
    <div class="title">{{title}}</div>
    <div class="main-body">
      <div class="text-title">{{item.title}}</div>
      <div class="desc">
        <span>作者: {{item.author}}</span>
        <span>发布时间: {{item.release_time}}</span>
        <span>来源: <span @click="toSource" class="text-source">{{item.source}}</span></span>
      </div>
      <div class="main-text" v-html="article.text">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "BaseArticle",
    props: {
      title: String,
      article: Object
    },
    data() {
      return {
       item: {}
      }
    },
    methods: {
      toSource() {
        let text = this.$router.resolve({
          name: 'index',
        })
        window.open(text.href, '_blank')
      }
    },
    watch: {
      article: {
        immediate: true,
        handler(val) {
          this.item = val
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.article-main {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #f9f9f9;
  border: solid 1px #d9d9d9;
  border-top: solid 2px #d43e42;
  .title {
    width: 758px;
    height: 40px;
    line-height: 40px;
    font-family: 'SourceHanSerifCN-Bold';
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0;
    color: #d43e42;
    border-bottom: solid 1px #d9d9d9;
  }
  .main-body {
    width: 640px;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .text-title {
      font-family: 'SourceHanSerifCN-Bold';
      font-size: 25px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0;
      color: #282828;
      text-align: center;
    }
    .desc {
      margin-top: 20px;
      display: flex;
      flex-direction: row;
      width: 360px;
      justify-content: space-between;
      span {
        font-family: 'SourceHanSansCN-Regular';
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0;
        color: #656565;
      }
      .text-source:hover {
        cursor: pointer;
        color: #d43e42;
        border-bottom: solid 1px #d43e42;
      }
    }
    .main-text {
      margin-top: 40px;
      width: 640px;
      margin-bottom: 220px;
      font-family: Alibaba-PuHuiTi-R;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0;
      color: #282828;
      white-space: pre-wrap;
      line-height: 25px;
      ::v-deep img {
        display: block;
        text-align: center;
        width: 400px;
      }
    }
  }
}
</style>
